import { View } from './view'

export const StepsPartners = View
